//This will be used by the business users to retrieve jobsites and toggle their status.

import axios from 'axios';

const foremanInvitations_API = '/api/worker/foreman/sendInvite';
const kyoskPunch_API = '/api/worker/foreman/kyoskPunch'
const getWorkerNextPunchType_API = '/api/worker/foreman/nextPunchType';
const sendTicketWorkersList_API = '/api/worker/foreman/sendTicketWorkersList';
// Retrieve all jobsites
const sendInvitation = async (token, inviteeData) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.post(foremanInvitations_API, inviteeData, config);

    return response.data;

}; 

// Get the next punch type for a selected worker at a jobsite.
// Selected worker data contains the worker Id and the jobsite id of the worker selected.
const getWorkersNextPunchType = async (selectedWorkerData, token) => {
   
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.post(getWorkerNextPunchType_API, selectedWorkerData, config);
    
    return response.data;

}; 


//Peroform a kyosk punch for a worker, clockIn or clockOut is determined by the nextPunchType and verified by the kyosk middleware in the backend.
//The punchData object must contain selectedWorkerId,sessionId, jobsiteId, punchType.

const kyoskPunch = async (punchData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.post(kyoskPunch_API, punchData, config);
    console.log("Kyosk punch response:", response.data);
    return response.data;

};         









//TicketList is an array of workerIds that are working as ticket.
const sendTicketWorkersList = async (token, ticketList) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.post(sendTicketWorkersList_API, {ticketList}, config);

    return response.data;

}; 











const foremanActionsService = {
    sendInvitation,
    kyoskPunch,

    getWorkersNextPunchType,
    sendTicketWorkersList
};

export default foremanActionsService;

